export default "__VITE_ASSET__CWyjW3EA__"